import React, { Fragment, useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Card, Tab, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faGlobeAmericas, 
    faMapMarkerAlt, 
    faCity, 
    faIndustry, 
    faUserTie, 
    faExclamationTriangle, 
    faBan,
    faCogs,
    faBook
} from '@fortawesome/free-solid-svg-icons';
import { loadingToggleAction, getParameterAction, getDictionnaireDataAction } from '../../../store/actions/AdministrationAction';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { useTranslation } from "react-i18next";
import './Parametrage.css';
// Import tab components
import CountryTab from './tabs/CountryTab';
import ProvinceTab from './tabs/ProvinceTab';
import CityTab from './tabs/CityTab';
import ActivityTab from './tabs/ActivityTab';
import ProfessionTab from './tabs/ProfessionTab';
import TypeExclusionTab from './tabs/TypeExclusionTab';
import ExclusionTab from './tabs/ExclusionTab';
import DictionaryTab from './tabs/DictionaryTab';

const Parametrage = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [updateMode, setUpdateMode] = useState(false);
    const [file, setFile] = useState(null);

    // Permission utility functions
    const canDo = (menuCode, actionCode) => {
        const theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if (!theMenu) {
            return false;
        } else {
            return theMenu.actionMenus?.some(action => action.code === actionCode);
        }
    };
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.some(menu => menu.code === menuCode) || false;
    };

    // Check access for different tabs
    const hasAccess = (type) => {
        switch(type) {
            case 'pays':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSPAYSPARAM');
            case 'province':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSPROVINCEPARAM');
            case 'ville':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSVILLEPARAM');
            case 'activité':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSACTIVITEPARAM');
            case 'profession':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSPROFESSIONPARAM');
            case 'types de motif exclusion':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSTYPEMOTIFEXCLUPARAM');
            case 'motif exclusion':
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSMOTIFEXCLUPARAM');
            case 'dictionnaire':
                console.log('Checking access for dictionaries :', canDo('MENPARAM', 'ACCESSDICTIONARIESPARAM'));
                return hasMenu('MENPARAM') && canDo('MENPARAM', 'ACCESSDICTIONARIESPARAM');
            default:
                return false;
        }
    };

    // Tab data with FontAwesome icons
    const tabData = [
        {
            label: t('common.country'),
            name: 'pays',
            icon: faGlobeAmericas,
            content: <CountryTab 
                        admin={props.admin}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.region'),
            name: 'province',
            icon: faMapMarkerAlt,
            content: <ProvinceTab 
                        provinces={props.provinces}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.city'),
            name: 'ville',
            icon: faCity,
            content: <CityTab 
                        admin={props.admin}
                        provinces={props.provinces}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.activity'),
            name: 'activité',
            icon: faIndustry,
            content: <ActivityTab 
                        admin={props.admin}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.job'),
            name: 'profession',
            icon: faUserTie,
            content: <ProfessionTab 
                        admin={props.admin}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.typ-motif-exl'),
            name: 'types de motif exclusion',
            icon: faExclamationTriangle,
            content: <TypeExclusionTab 
                        typesExclusions={props.typesExclusions}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.motif-exl'),
            name: 'motif exclusion',
            icon: faBan,
            content: <ExclusionTab 
                        admin={props.admin}
                        typesExclusions={props.typesExclusions}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
        {
            label: t('common.dictionaries'),
            name: 'dictionnaire',
            icon: faBook,
            content: <DictionaryTab 
                        admin={props.admin}
                        showLoading={props.showLoading}
                        showProvLoading={props.showProvLoading}
                        hasMenu={hasMenu}
                        canDo={canDo}
                        dispatch={dispatch}
                     />
        },
    ];

    useEffect(() => {
        if (hasMenu('MENPARAM') && canDo('MENPARAM', 'VIEWPARAM')) {
            dispatch(loadingToggleAction());
            dispatch(getParameterAction());
            dispatch(getDictionnaireDataAction('type-exclusion'));
            dispatch(getDictionnaireDataAction('province'));
            dispatch(getDictionnaireDataAction('dictionnaire'));
        } else {
            props.history.push('/access-denied');
        }
    }, []);

    return (
        <Fragment>
            <Row>
                <Col xl={12}>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0 pb-0">
                            <div>
                                <Card.Title className="mb-1 h4">
                                    <FontAwesomeIcon icon={faCogs} className="text-primary me-2" />
                                    {t("common.parameters")}
                                </Card.Title>
                                <p className="text-muted mb-0 small">{t("common.manage-system-parameters")}</p>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0 pt-0">{/* Remove top padding from body */}
                            {/* Clean Nav tabs without borders */}
                            <div className='custom-tab-1'>
                                <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                                    <Nav as='ul' className='nav-tabs bg-white px-3 pt-2' style={{ border: 'none' }}>{/* Reduced top padding */}
                                        {tabData.map((data, i) => (
                                            <Nav.Item as='li' key={i} className="me-1">
                                                <Nav.Link 
                                                    disabled={updateMode || file || !hasAccess(data.name.toLowerCase())} 
                                                    eventKey={data.name.toLowerCase()}
                                                    className={`px-3 py-2 ${
                                                        updateMode || file || !hasAccess(data.name.toLowerCase()) 
                                                            ? 'text-muted' 
                                                            : 'text-primary'
                                                    }`}
                                                    style={{ 
                                                        border: 'none',
                                                        background: 'transparent',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={data.icon} className="me-2" />
                                                        <span className="fw-medium">{data.label}</span>
                                                    </div>
                                                </Nav.Link>
                                            </Nav.Item>
                                        ))}
                                    </Nav>
                                    <Tab.Content className='bg-white'>
                                        {tabData.map((data, i) => (
                                            <Tab.Pane eventKey={data.name.toLowerCase()} key={i} className="p-0">
                                                <div className="bg-white p-0">
                                                    {data.content}
                                                </div>
                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        errorMessage: state.admin.errorMessage,
        successMessage: state.admin.successMessage,
        showLoading: state.admin.showLoading,
        admin: state.admin.administration,
        provinces: state.admin.provinces,
        typesExclusions: state.admin.typesExclusions,
        dictionaries: state.admin.dictionaries || [],
        showProvLoading: state.provider.showLoading,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(Parametrage);